import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { get as lodashGet } from "lodash";
import { Modal, Button, Typography } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PhoneIcon from "src/assets/phone.png";
import PinIcon from "src/assets/pin.png";

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  width: 85%;
  height: 75vh;
  padding: 10px 15px;
  &:focus {
    outline: none;
  }
  .header {
    text-align: right;
  }
  .store_list {
    color: #7b7c7e;
    height: 70vh;
    padding: 0 25px;
    overflow-y: scroll;
  }

  .title {
    margin-top: 20px;
    text-align: center;
    color: black;
    > h4 {
      margin-left: 11px;
      letter-spacing: 12px;
      font-size: 1.8rem;
    }
  }
  .bottom_line {
    margin: 8px auto 15px;
    width: 50px;
    border-top: 1px solid #969699;
  }
  .store_item {
    padding: 15px 0;
    line-height: 1.5;
    border-bottom: 1px solid #969699;
    img {
      height: 24px;
      margin-right: 10px;
    }
    a {
      text-decoration: none;
    }
    > p {
      display: flex;
      letter-space: 1px;
      margin-bottom: 12px;
      font-weight: normal;
      svg {
        height: 24px;
        width: auto;
        margin-right: 10px;
      }
    }
    > p:nth-child(1) {
      font-size: 1.5rem;
      color: black;
      margin-bottom: 14px;
      letter-spacing: 1px;
    }
    > p:nth-child(2),
    > p:nth-child(3) {
      align-items: center;
      letter-spacing: 1px;
      font-size: 1.1rem;
    }
  }

  .store_area {
    margin-top: 130px;
  }
`;
// 包括臺北市、新北市、基隆市、新竹市、桃園市、新竹縣及宜蘭縣。
// 中部區域：包括臺中市、苗栗縣、彰化縣、南投縣及雲林縣。
// 南部區域：包括高雄市、臺南市、嘉義市、嘉義縣、屏東縣及澎湖縣。

const renderStore = (store) => {
  return (
    <div className="store_item">
      <Typography>{store.name}</Typography>
      <Typography>
        <img alt="phone-icon" src={PhoneIcon} />{" "}
        <a style={{ color: "#7b7c7e" }} href={`tel:${store.phone}`}>
          {store.phone}
        </a>
      </Typography>
      <Typography>
        <img alt="pin-icon" src={PinIcon} /> <div> {store.address}</div>
      </Typography>
    </div>
  );
};

const StoreModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const storesList = useSelector((state) => state.ajax.storesList);
  const formatStoreList = lodashGet(storesList, ["data", "rows"], [])
    .sort((a, b) => a.order - b.order)
    .map((store) => {
      const city = store.address.slice(0, 2);
      return { city, ...store };
    })
    .reduce(
      (acc, store) => {
        const { city } = store;
        switch (city) {
          case "台北":
          case "新北":
          case "基隆":
          case "桃園":
          case "宜蘭": {
            acc.north.push(store);
            break;
          }
          case "新竹":
          case "台中":
          case "苗栗":
          case "彰化":
          case "南投":
          case "雲林": {
            acc.mid.push(store);
            break;
          }
          default:
            acc.south.push(store);
        }
        return acc;
      },
      {
        north: [],
        mid: [],
        south: [],
      }
    );

  const openModal = () => {
    // getStore
    setIsOpen(true);
  };
  return (
    <>
      <Button className="coupon_btn" variant="outlined" onClick={openModal}>
        櫃點查詢​
      </Button>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Wrapper>
          <div className="header">
            <CloseOutlinedIcon
              onClick={() => setIsOpen(false)}
              className="close_icon"
              color="primary"
            />
          </div>
          <div className="store_list">
            <div>
              <div className="title">
                <Typography variant="h4" align="center">
                  北部
                </Typography>
                <div className="bottom_line" />
              </div>
              {formatStoreList.north.map(renderStore)}
            </div>
            <div className="store_area">
              <div className="title">
                <Typography variant="h4" align="center">
                  中部
                </Typography>
                <div className="bottom_line" />
              </div>
              {formatStoreList.mid.map(renderStore)}
            </div>
            <div className="store_area">
              <div className="title">
                <Typography variant="h4" align="center">
                  南部
                </Typography>
                <div className="bottom_line" />
              </div>
              {formatStoreList.south.map(renderStore)}
            </div>
          </div>
        </Wrapper>
      </Modal>
    </>
  );
};

export default StoreModal;
